













































































import Vue, { VueConstructor } from 'vue';
import { BButton } from 'bootstrap-vue';

import { mapActions } from '@/state/modules/survey_builder';
import { Question } from '@/state/modules/survey_builder/state';
import {
  isQuestionTypeAdditionalText,
  questionHasWeight,
  getMinQuestionScore,
  getMaxQuestionScore,
} from '@/state/modules/survey_builder/helpers';

import questionComponents from './questionComponents';

export default Vue.extend({
  name: 'Question',
  provide() {
    return {
      csrfToken: '',
      apiUploadFileUrl: '',
      apiDeleteFileUrl: '',
    };
  },
  components: {
    BButton,
  },
  props: {
    surveyId: {
      type: Number,
      required: false,
      default: null,
    },
    question: {
      type: Object as () => Question,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    isWeighted: {
      type: Boolean,
      required: true,
    },
    isLast: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    component(): VueConstructor {
      return questionComponents[this.question.type!];
    },
    hasAdditionalText(): boolean {
      return isQuestionTypeAdditionalText(this.question);
    },
    hasScore(): boolean {
      return this.isWeighted && questionHasWeight(this.question);
    },
    minScore(): number {
      return getMinQuestionScore(this.question);
    },
    maxScore(): number {
      return getMaxQuestionScore(this.question);
    },
  },
  methods: {
    ...mapActions({
      remove: 'removeQuestion',
      addAnother: 'addAnotherQuestion',
    }),
    onClick(event: Event) {
      this.$emit('click', event);
    },
  },
});
